import { $ } from './../helpers/query'

export default () => {
  $('.building').each((section) => {

    // culc sum on input checked

    let officesSum = 0;
    let inputsSum = 0;

    $('.custom-checkbox input', section).on('change', (e, input) => {
      const isRetail = input.closest('.custom-checkbox').matches('.custom-checkbox--retail');
      const numText = input.closest('tr').querySelector('.calc-val').innerHTML;
      const num = +replace(numText, ',', '.');

      if (input.checked) {
        if (!isRetail) officesSum += num;
        inputsSum += num;
      } else {
        if (!isRetail) officesSum -= num;
        inputsSum -= num;
      }
      officesSum = officesSum.toFixed(3);
      inputsSum = inputsSum.toFixed(3);

      let officesResult = +officesSum === 0 ? 0 : replace(`${officesSum}`, '.', ',');
      let result = +inputsSum === 0 ? 0 : replace(`${inputsSum}`, '.', ',');

      section.querySelector('.calc-office-total').innerHTML = officesResult;
      section.querySelector('.calc-building-total').innerHTML = result;

      officesSum = +officesSum;
      inputsSum = +inputsSum;
    })

    // highlight floors on table row hover

    $('.building-table [data-floor]', section).on('mouseenter', (e, row) => {
      if (!row.matches('.touch')) {
        const id = row.getAttribute('data-floor');
        section.querySelector(`.building-img [data-floor="${id}"]`).classList.add('active')
      }
    })

    $('.building-table [data-floor]', section).on('mouseleave', (e, row) => {
      if (!row.matches('.touch')) {
        const id = row.getAttribute('data-floor');
        section.querySelector(`.building-img [data-floor="${id}"]`).classList.remove('active')
      }
    })

    setTouchClass()
    window.addEventListener('resize', () => {
      setTouchClass()
    })

    function setTouchClass() {
      const isTouch = navigator.userAgent.match(/iPad|iPhone|Android/i);
      if (isTouch) {
        $('[data-floor]', section).addClass('touch')
      }
    }

  })
}

function replace(text, inputSym, outputSym) {
  const textLetters = text.split('');
  textLetters.forEach((letter, i) => {
    if (letter == inputSym) {
      textLetters[i] = outputSym;
    }
  });
  return textLetters.join('')
}
